import { IColoursSetting } from './colours';

export interface IColoursSettingUpdate {
    data: IColoursSetting;
}
